module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'tabStrip',
        'slider',
    ],

    model: {
        stepComplete: {}, // stores which forms has been submitted by tabs registerSecret
    },

    methods: {
        stepComplete(){
            this.model.stepComplete[this.model.activeRegisterSecret] = true
        },
    },

    hooks: {
        _attach(){
            const storage = this.getStorage()
            const view = (((storage || {}).request || {}).routeParams || {}).view || 'register'

            if(view && (this.registry || {})[view]){
                this.focusTab(view)
            }
        }
    }
}